import React, { useState } from 'react'

import { MetaText, Markup, Modal } from '@pb/components'
import { getLabelFromStorage, replacePlaceholdersWithComponents } from '@pb/utils'
import { compose, flip, concat, join, drop, split } from 'ramda'

import useHTML from 'hooks/useHTML'

import styles from './PrivacyPolicyModal.scss'

const PrivacyPolicyModal: React.FC<any> = ({ link }) => {
  const { linkText, linkTextV2, path, label, klarnaLink, klarnaLinkLabel } = link
  const [shouldShowPrivacyPolicy, setShouldShowPrivacyPolicy] = useState(false)

  // modify path from :: "/content/hmonline/en_gb/customer-service/legal-and-privacy/privacy-link"
  // to               :: "customer-service/legal-and-privacy/privacy-link.modal.html"
  const endpoint = compose(flip(concat)('.modal.html'), join('/'), drop(4), split('/'))(path)

  const { data: privacyPolicyHtml, isLoading, error } = useHTML(endpoint)

  const showPrivacyPolicy = (e): any => {
    e.preventDefault()
    setShouldShowPrivacyPolicy(true)
  }

  const togglePrivacyPolicy = (): any => {
    setShouldShowPrivacyPolicy(false)
  }

  return (
    <>
      <MetaText Tag="p" className={styles.privacyFootnote}>
        {replacePlaceholdersWithComponents(linkTextV2 || linkText, [
          <a href="#!" onClick={showPrivacyPolicy} type="button" key={label}>
            {label}
          </a>,
          <a href={klarnaLink} target="_blank" rel="noopener noreferrer" key={klarnaLinkLabel}>
            {klarnaLinkLabel}
          </a>,
        ])}
      </MetaText>

      {!isLoading && !error && privacyPolicyHtml && (
        <Modal
          closeButtonText={getLabelFromStorage('general.close')}
          title={label}
          isOpen={shouldShowPrivacyPolicy}
          toggleModal={togglePrivacyPolicy}
          className={styles.modal}
        >
          <Markup Tag="div" sanitized={false} input={privacyPolicyHtml} />
        </Modal>
      )}
    </>
  )
}

export default PrivacyPolicyModal
